// @ts-nocheck
import { TEMPLE_R, BUCKET_SZ, DECOR_BUCKET, MIN_HOLE_SEPARATION } from "./constants";
import { mapState } from "./state";

// Seeded hash
export function hsh(a, b, s) {
  let h = s | 0;
  h = (h * 2654435761 + a * 374761393) | 0;
  h = (h * 2654435761 + b * 668265263) | 0;
  h = ((h ^ (h >>> 13)) * 1274126177) | 0;
  return (h ^ (h >>> 16)) >>> 0;
}

export function srand(a, b, s) {
  return (hsh(a, b, s) % 10000) / 10000;
}

export function inTemple(x, y) {
  return Math.abs(x) < TEMPLE_R && Math.abs(y) < TEMPLE_R;
}

export function registerHole(x, y) {
  const bx = Math.floor(x / BUCKET_SZ),
    by = Math.floor(y / BUCKET_SZ);
  const bk = bx + "," + by;
  if (!mapState.holeBuckets[bk]) mapState.holeBuckets[bk] = [];
  mapState.holeBuckets[bk].push({ x, y });
}

export function tooCloseToAnyHole(px, py, minDist) {
  const md2 = minDist * minDist;
  const bx0 = Math.floor((px - minDist) / BUCKET_SZ);
  const bx1 = Math.floor((px + minDist) / BUCKET_SZ);
  const by0 = Math.floor((py - minDist) / BUCKET_SZ);
  const by1 = Math.floor((py + minDist) / BUCKET_SZ);
  for (let by = by0; by <= by1; by++) {
    for (let bx = bx0; bx <= bx1; bx++) {
      const arr = mapState.holeBuckets[bx + "," + by];
      if (!arr) continue;
      for (let i = 0; i < arr.length; i++) {
        const dx = px - arr[i].x,
          dy = py - arr[i].y;
        if (dx * dx + dy * dy < md2) return true;
      }
    }
  }
  return false;
}

export function holesWouldOverlap(px, py, qx, qy, minDist = MIN_HOLE_SEPARATION) {
  const dx = px - qx;
  const dy = py - qy;
  const md2 = minDist * minDist;
  return dx * dx + dy * dy < md2;
}

export function registerDecor(x, y, radius) {
  const bx = Math.floor(x / DECOR_BUCKET),
    by = Math.floor(y / DECOR_BUCKET);
  const bk = bx + "," + by;
  if (!mapState.decorBuckets[bk]) mapState.decorBuckets[bk] = [];
  mapState.decorBuckets[bk].push({ x, y, r: radius });
}

export function tooCloseToAnyDecor(px, py, minDist) {
  const bx0 = Math.floor((px - minDist) / DECOR_BUCKET);
  const bx1 = Math.floor((px + minDist) / DECOR_BUCKET);
  const by0 = Math.floor((py - minDist) / DECOR_BUCKET);
  const by1 = Math.floor((py + minDist) / DECOR_BUCKET);
  for (let by = by0; by <= by1; by++) {
    for (let bx = bx0; bx <= bx1; bx++) {
      const arr = mapState.decorBuckets[bx + "," + by];
      if (!arr) continue;
      for (let i = 0; i < arr.length; i++) {
        const dx = px - arr[i].x,
          dy = py - arr[i].y;
        const need = minDist + arr[i].r;
        if (dx * dx + dy * dy < need * need) return true;
      }
    }
  }
  return false;
}

export function canPlaceDecor(x, y, halfSize) {
  let holeDist = halfSize + MIN_HOLE_SEPARATION * 0.45;
  if (holeDist < MIN_HOLE_SEPARATION) holeDist = MIN_HOLE_SEPARATION;
  if (tooCloseToAnyHole(x, y, holeDist)) return false;
  if (tooCloseToAnyDecor(x, y, halfSize + 10)) return false;
  return true;
}
